import React, { useEffect, useState, version } from 'react'
import axios from 'axios'

import {render} from 'react-dom'
import {postier} from './Postier'
import {useCookies,CookiesProvider} from 'react-cookie'

import LogonRestit from './LoginRestit' 

function App(){

    

    return(<CookiesProvider>
        
        <Manager/>
        
    </CookiesProvider>)
}

function Manager(){

    const [version,setVersion] = useState("")

    useEffect(()=>{
        axios.get("/version").then(res=>{
            setVersion(res.data)
        })
    },[])

    return <div>
        {(version=="occupation")?<LogonRestit />:<Login />}
    </div>
}

function Login() {

    const [sites,setSites] = useState([])
    const [clients,setClients] = useState([])
    const [client,setClient]=useState("")

    const [id_user,setId_user]=useState("")

    const [username,setUsername] = useState("")
    const [password,setPassword] = useState("")

    const [page,setPage] = useState(1)

    const [post, setPost] = useState()

    useEffect(() => {
        const url = window.location.href
        const id_Site=url.split('//')[1].split('/')[1];
        ("occupation"==id_Site)?setPost("/loginoccupation"):setPost("/login")
        console.log({id_Site})
    }, [username,password])

    useEffect(()=>{
        if(clients[0]){
            setClient(clients[0])
        }
    },[clients])

    useEffect(()=>{
        (id_user!="")?getSite():null;
    },[id_user])

    const getclients = (e)=>{
        e.preventDefault()
        setPage(2)
        postier.getClients(username,password,setClients,setId_user)
    }

    const getSite = (e)=>{
        // e.preventDefault()
        console.log("Sites")
        setPage(3)
        postier.getLoginSites(client,id_user,setSites)
    }

    //Page de connexion 1

    const Login = <form id="form" onSubmit={getclients} className="contain">
                    <div className="LoginTitle">veuillez vous connecter  </div>
                        <input id="username" name="username" value={username} onChange={(e)=>{setUsername(e.target.value)}} className=" formulaire" placeholder="username" />
                        <input id="password" name="password" value={password} onChange={(e)=>{setPassword(e.target.value)}} type="password" className="formulaire" placeholder="password"  />
                        <button id="submit" type="submit" className="btn-info formulaire" >Se Connecter</button>
                </form>

    //Page 2

    const selectClient = <form id="form" onSubmit={getSite} className="contain">
                            <div className="LoginTitle"> chargement... </div>
                        </form>
    
    //Page3

    const Accueil = <form id="form" className="contain" action={`${post}`} method="post">
                        <div className="LoginTitle"> Choisissez le site </div>
                            <input id="client" name="client" hidden value={client} onChange={(e)=>{}} className=" formulaire" placeholder="client" />
                            <input id="username" name="username" hidden value={username} onChange={(e)=>{setUsername(e.target.value)}} className=" formulaire" placeholder="username" />
                            <input id="password" name="password" hidden value={password} onChange={(e)=>{setPassword(e.target.value)}} type="password" className="formulaire" placeholder="password"/>
                            <select name="id_site" className="formulaire">
                                {sites.map(site=><option key={site.id_site} value={site.id_site}>{site.site_name}</option>)}
                                </select>
                            <button id="submit" type="submit" className="btn-info formulaire" >Accéder au site</button>
                    </form>


    return (
        <>
            {(page==1)?Login:null}
            {(page==2)?selectClient:null}
            {(page==3)?Accueil:null}
        </>
    )
}

render(<App/>,document.getElementById('app'))